
import { getAllActivePaymentMode } from "views/pages/manage/masters/studentFinancials/paymentCollection/bulkCollection/utils";
import { useEffect, useState } from "react";
import { masterServiceBaseUrl } from "services/http";
import { endpoint } from "views/pages/manage/common/constant";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  dropdownMapping as masterDropdownMapping,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { dropdownMapping } from "views/pages/manage/unAssigned/studentCharges/common";
import { payModeProcessTagTypeMapping, vendorPayModeUploadDropdown } from "./utils";
import { useGetUserRoledId } from "views/pages/manage/unAssigned/examCharges/context/customHooks";

export const validateVendorPan = async (body) => {
  const url = `${endpoint?.vendorManagement?.validatePanNumber}?panNumber=${body.panCardNumber}`;
  return await fetchAllPromisedData(url, true);
};

const dropdownPostMapping = async (url) => {
  const resp = await fetchAllPostPromisedData(url, {});
  const bankList = resp?.data?.bankMasterList ?? [];
  const allBanks = bankList?.map((bank) => ({
    ...bank,
    label: bank?.bankName,
    value: bank?.id,
  }));
  return allBanks;
};

export const createVendor = async (body) => {
  return await fetchAllPostPromisedData(
    endpoint?.vendorManagement?.createVendor,
    body,
    "post",
  );
};

export const editVendor = async (body, vendorId) => {
  return await fetchAllPostPromisedData(
    `${endpoint?.vendorManagement?.updateVendor}`,
    {id: vendorId, ...body} ,
    "put",
  );
};

export const getVendorById = async (vendorId) => {
  return await fetchAllPromisedData(
    `${endpoint?.vendorManagement?.getById}/${vendorId}`,
    true);
};
 

export const getDropdowns = async (setDropdowns, roleId) => {
  const p = await Promise.all([
    dropdownMapping(
      endpoint.languageMaster.getActiveLanguageMaster,
      "languageDispValue",
    ),
    masterDropdownMapping(
      endpoint.businessArea.getAllActiveV2,
      "businessAreaDispValue",

      "id",
      "sapPlantId",
    ),
    dropdownMapping(masterServiceBaseUrl + "/city/getAllCity", "cityDispValue"),
    dropdownMapping(
      masterServiceBaseUrl + "/state/getAllState",
      "stateDispValue",
    ),
    dropdownMapping(
      masterServiceBaseUrl + "/country/getAllCountry",
      "countryDispValue",
    ),
    dropdownPostMapping(`${endpoint.bankMaster.search}?offset=-1`),
    getAllActivePaymentMode(roleId, payModeProcessTagTypeMapping,vendorPayModeUploadDropdown),
    dropdownMapping(
      endpoint.jobTitle.getAll,
      "jobTitleKey"),

  ]);
  dropdownMapping(
        endpoint.personType.getAllActive,
        "personTypeDispValue"


  )

   
  const dropdownData = {
    languages: p[0],
    buCodes: p[1],
    cities: p[2],
    states: p[3],
    countries: p[4],
    bankCodes: p[5],
    paymentMethods: (p[6]?.accessibleList?? []).map(item => ({...item, label: item?.paymentModeDispValue, value: item?.paymentModeKey })),
    designations: p[7],
    personTypes: p[8],
  };
  setDropdowns(dropdownData);
};

export const useFetchDropdowns = () => {
  const [dropdowns, setDropdowns] = useState({});
  const [loading, setLoading] = useState(false);  
   const roleId = useGetUserRoledId();
  useEffect(() => {
    setLoading(true);
    roleId && getDropdowns(setDropdowns, roleId).finally(() => setLoading(false));
  }, [roleId]);
  return { dropdowns, isDropdownLoading: loading };
};

export const verifyPinCode = async (
  pinCode,
  form,
  setForm,
  { cities, states, countries },
) => {
  const url = `${endpoint?.pincode?.getPinCodeDetails}/${pinCode}`;
  const pinCodeDetails = await fetchAllPromisedData(url, true);
  if (pinCodeDetails?.code === 200) {
    const { cityId, stateId, countryId } = pinCodeDetails?.data;

    setForm({
      ...form,
      city: cities.find((city) => city.value === cityId),
      state: states.find((state) => state.value === stateId) || null,
      country: countries.find((country) => country.value === countryId),
    });

    return true;
  }
};



export const verifyEmpId = async (empId, setForm, ) => {
  const url = `${endpoint.getEmployeeDetails}/${empId}`;
  const response = await fetchAllPromisedData(url, true, false);
  if (response?.code == 200) {
    console.log("Employee details fetched successfully:", response.data);
    setForm((prev) => ({
      ...prev,
      referenceEmployeeName: response.data.employeeName,
      referenceDesignation: response.data.designation,
      isEmpVerified: true,
    }));

    return true;
     
  }
};

